import { CultureInfo } from '../culture-info.model';
import { CultureInfoLn } from './ln';

/**
 * @ignore
 */
export const CultureInfoLnAO: CultureInfo = {
  name: 'ln-AO',
  displayName: 'lingála (Angóla)',
  iso3LanguageCode: 'lin',
  iso2LanguageCode: 'ln',
  ietfLanguageTag: 'ln-AO',
  parent: CultureInfoLn
};
